export const SHOW_WELCOME_MODAL = 'show_welcome_modal_v2';
